/* ============================================
   Boss Laser Products Mega Menu — Hover Tab Switcher
   ============================================ */
(function () {
  function initMegaMenu() {
    const roots = document.querySelectorAll('[data-mp-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.mpInit === 'true') return;
      root.dataset.mpInit = 'true';

      const tabs = root.querySelectorAll('[data-mp-tab]');
      const panels = root.querySelectorAll('[data-mp-panel]');

      function activate(key) {
        if (!key) return;
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t.dataset.mpTab === key);
        });
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.dataset.mpPanel === key);
        });
      }

      tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => activate(tab.dataset.mpTab));
        tab.addEventListener('focus', () => activate(tab.dataset.mpTab));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }

  // Re-init on Shopify section reload (theme editor / ajax)
  document.addEventListener('shopify:section:load', initMegaMenu);
})();